export { DMS_MODULE } from '../constants';
export const NAME = 'PartSales';
export const API_NAME = 'PartSales';
export const EXPORT_FILE_NAME='PartSales.xlsx';
export const CRUMB_LABEL_KEY = 'PartSales';


export type SestavaButton = { labelKey: string, routeName: string, api: string, permission: number };

